/** 共享 UI 原语（参考 v0 设计语言）：Section 卡片、Label、NumInput、FormRow。 */
import { cn } from './cn';

export function Label({ children, htmlFor }: { children: React.ReactNode; htmlFor?: string }) {
  return (
    <label
      htmlFor={htmlFor}
      className="block text-[11px] font-mono uppercase tracking-wider text-muted-foreground mb-1"
    >
      {children}
    </label>
  );
}

export function NumInput({
  value,
  onChange,
  min,
  max,
  step = 1,
  id,
  unit,
}: {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  id?: string;
  unit?: string;
}) {
  return (
    <div className="relative flex items-center">
      <input
        id={id}
        type="number"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-8 bg-input/40 border border-border rounded px-2.5 text-sm num text-foreground
          focus:outline-none focus:ring-1 focus:ring-primary/60 focus:border-primary/40 transition-colors"
      />
      {unit && (
        <span className="absolute right-2 text-[10px] text-muted-foreground pointer-events-none">{unit}</span>
      )}
    </div>
  );
}

export function FormRow({ label, children, id }: { label: string; children: React.ReactNode; id?: string }) {
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id}>{label}</Label>
      {children}
    </div>
  );
}

export function Section({
  title,
  children,
  icon: Icon,
  className,
}: {
  title: string;
  children: React.ReactNode;
  icon?: React.ComponentType<{ className?: string }>;
  className?: string;
}) {
  return (
    <div className={cn('rounded-lg border border-border bg-card p-5 flex flex-col gap-4', className)}>
      <div className="flex items-center gap-2 border-b border-border pb-3">
        {Icon && <Icon className="w-4 h-4 text-primary" />}
        <h2 className="text-sm font-semibold text-foreground tracking-tight">{title}</h2>
      </div>
      {children}
    </div>
  );
}
